import styled from '@emotion/styled';

import variables from 'theme/styles/vars';

export default styled.div`
	position: relative;
	width: 100%;
	padding: 2em 0;

	.top {
		display: flex;
		justify-content: center;
		align-items: center;
		padding-bottom: 3em;
		border-bottom: 0.1em solid #000000;
		.btn-container {
			display: flex;
			justify-content: center;
			align-items: center;
			.variant-primary {
				margin-right: 1em;
			}

			.phone-btn {
				.button {
					min-width: 16em;
					width: 100%;
					display: flex;

					.hover-container {
						width: 100%;
					}
				}
			}
		}
	}

	.main {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.description {
		font-size: 0.85em;
		color: #afaead;
		padding-top: 2.8em;
	}
	@media all and (max-width: ${variables.mobileL}) {
		.top {
			.btn-container {
				flex-direction: column;
				max-width: max-content;
				margin: 0 auto;
				.variant-primary {
					margin-right: 0;
					.button {
						width: 100%;
					}
				}
				.phone-btn {
                    min-width: 100%;
                    margin-top: 1em;

					.button {
						min-width: 100%;
						width: 100%;
						display: flex;

						.hover-container {
							width: 100%;
						}
					}
				}
			}
		}
	}
	@media all and (max-width: ${variables.mobileM}) {
		font-size: 126%;
		.description {
			display: none;
		}
	}
`;
